export const USER_ROLE_ADMIN = 1
export const USER_ROLE_MANAGER = 2
export const USER_ROLE_DRIVER = 3